/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/more_vertical'
export default icon
